import Slider from "./Slider";
import CustomerSupport from "../../Components/Home/CustomerSupport/CustomerSupport";
import Makes from "./Makes";
import Sections from "../SpareParts/Catelog/Sections";
import useIsMobile from "../../Helper/useIsMobile";
import MobSection from "../SpareParts/Catelog/MobSection";
import { Helmet } from "react-helmet";
import ShopByBrands from "./ShopByBrands";
import MembershipPolicy from "./MembershipPolicy";
import RedeemOfferSlider from "./RedeemOfferSlider";
import NewArrivalsBanner from "./NewArrivalsBanner";
import OsscaBanner from "./OsscaBanner";
import ShopByOEBrands from "./ShopByOEBrands";
import { useContext, useEffect } from "react";
import { ConfigContext } from "../../Context/ConfigContext";
import BatteriesSlider from "./BatteriesSlider";
import UpcomingRedeemOffer from "./UpcomingRedeemOffer/UpcomingRedeemOffer";

const Home = () => {
    const isMobile = useIsMobile();

    const { currency } = useContext(ConfigContext);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [])

    return (
        <div>
            <Helmet>
                <title>Ghayar Spare Parts - Your Trusted Auto Parts Supplier in UAE</title>
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="format-detection" content="telephone=no" />
                <meta name="csrf-token" content="VeV893Poy3i5QHyNChCCGZVxaFTw34sv7Rd61d3X" />
                <meta name="robots" content="index, follow" />
                <meta name="description" content="Ghayar LLC - Leading supplier of genuine car parts in UAE. Fast delivery across Dubai, Abu Dhabi & KSA. Shop now for quality spare parts with flexible returns." />
                <meta name="keywords" content="car parts UAE, spare parts Dubai, auto parts Abu Dhabi, vehicle parts KSA, genuine car parts, auto components UAE, car maintenance parts, car repair parts" />
                <meta property="og:image" content="https://business.ghayar.com/assets/images/Logo/car7_transparent_powered_by.png" />
                <meta property="og:title" content="Ghayar LLC - Your Trusted Auto Parts Supplier in UAE" />
                <meta property="og:description" content="Ghayar LLC - Leading supplier of genuine car parts in UAE. Fast delivery across Dubai, Abu Dhabi & KSA. Shop now for quality spare parts with flexible returns." />
                <meta property="og:url" content="https://ghayar.com/" />
                <meta name="google-site-verification" content="sqbHPE0JL6KdK0P-oI0unVHXTA2jxGM9cebO3qfkyqE" />
                <meta property="twitter:title" content="Ghayar LLC - Your Trusted Auto Parts Supplier in UAE" />
                <meta property="twitter:description" content="Ghayar LLC - Leading supplier of genuine car parts in UAE. Fast delivery across Dubai, Abu Dhabi & KSA. Shop now for quality spare parts with flexible returns." />
                <meta property="twitter:url" content="https://ghayar.com/" />
                <link rel="canonical" href="https://ghayar.com/" />
            </Helmet>
            <Slider />
            <OsscaBanner />
            <ShopByBrands />
            {
                (currency || "").toLowerCase() !== "usd" &&
                <UpcomingRedeemOffer />
            }
            <NewArrivalsBanner />
            <ShopByOEBrands />
            {/* <BatteriesSlider /> */}
            {isMobile ? <MobSection /> : <Sections from={true} />}
            <section className="f" >
                <Makes />
            </section>
            <CustomerSupport />
            {
                (currency || "").toLowerCase() !== "usd" &&
                <>
                    <MembershipPolicy />
                    <RedeemOfferSlider />
                </>
            }
        </div>
    );

}
export default Home;